import { cn } from "@/lib/utils";

type HeroBlockProps = {
  wrapperStyle?: string;
  bgStyle?: string;
  children?: React.ReactNode;
};

const HeroBlock = ({ wrapperStyle, bgStyle, children }: HeroBlockProps) => {
  return (
    <div className={cn("relative isolate flex w-full items-center justify-center", bgStyle)}>
      <div
        className={cn(
          "mx-auto flex w-full max-w-screen-2xl flex-col px-4 py-20 md:px-12 lg:px-[120px] lg:py-[120px]",
          wrapperStyle,
        )}
      >
        {children}
      </div>
    </div>
  );
};

export default HeroBlock;
